// extracted by mini-css-extract-plugin
export default {"Title":"Matting_Title__1aeAQ","Controller":"Matting_Controller__WZhc6","Content":"Matting_Content__K2LJp","DragAndScale":"Matting_DragAndScale__1Gfun","Tips":"Matting_Tips__ALDAS"};